module.exports = __webpack_public_path__ + "assets/8560665dffbe0fed1d1ffe6a07de9256.svg";